import React, { Suspense, useContext } from "react";
import {
  LayoutComponent,
  LoaderComponent,
  TreeConfig,
} from "beelean-component-library";
import AccountList from "../components/account/AccountList";
import {
  getCorrectLanguageImage,
  toggleLanguage,
  useLayoutConfiguration,
} from "../utils/NavigationUtil";
import {
  GlobaleApplicationSettings,
  KeycloakUserContext,
  CompanyContext,
  TreeDataContext,
} from "./App";
import { Company, KeycloakUser } from "../utils/Interfaces";
import { isModuleValidInLicense } from "../utils/LicenseUtil";
import { useTranslation } from "react-i18next";
import { LicenseModuleType } from "../utils/Enums";

interface AccountListPageProps {
  keycloakUser: KeycloakUser;
  userCompany: Company;
  leanAdminTreeData?: TreeConfig;
  pdcaTreeData?: TreeConfig;
  projektAkteTreeData?: TreeConfig;
  leanProdTreeData?: TreeConfig;
  isViewerState: boolean;
  toggleViewerState: Function;
  isDesktopMenuOpen: boolean;
  toggleIsDesktopMenuOpen: Function;
}

const Page: React.FC<AccountListPageProps> = ({
  keycloakUser,
  userCompany,
  leanAdminTreeData,
  pdcaTreeData,
  leanProdTreeData,
  isViewerState,
  toggleViewerState,
  isDesktopMenuOpen,
  toggleIsDesktopMenuOpen,
  projektAkteTreeData,
}) => {
  const {
    text,
    isAdmin,
    username,
    homeFunction,
    logoutFunction,
    accountListFunction,
    profileFunction,
    isPlatformAdmin,
    showToggleViewEdit,
    isTest,
    lng,
  } = useLayoutConfiguration(keycloakUser);
  const { t } = useTranslation();

  return (
    <LayoutComponent
      noDataInTree={t("tree.noData")}
      isTest={isTest}
      showToggleViewEdit={showToggleViewEdit}
      isDesktopMenuOpen={isDesktopMenuOpen}
      onToogleDesktopMenuOpen={() =>
        toggleIsDesktopMenuOpen(!isDesktopMenuOpen)
      }
      viewEditStatus={isViewerState}
      adminProjektAkteTreeData={projektAkteTreeData}
      onToggleViewEditFunction={() => toggleViewerState(!isViewerState)}
      showLeanAdminTree={
        isPlatformAdmin ||
        isModuleValidInLicense(
          LicenseModuleType.ADMINISTRATION,
          userCompany.license
        )
      }
      showLeanProdTree={
        isPlatformAdmin ||
        isModuleValidInLicense(
          LicenseModuleType.PRODUCTION,
          userCompany.license
        )
      }
      text={text}
      adminPdcaTreeData={pdcaTreeData}
      title={t("user.headline")}
      leanProdTreeData={leanProdTreeData}
      leanAdminTreeData={leanAdminTreeData}
      username={username}
      homeFunction={() => homeFunction()}
      logoutFunction={() => logoutFunction()}
      onUserAdminFunction={() => accountListFunction()}
      onCreateLineFunction={() => console.log("Cretae Line!")}
      isAdmin={isAdmin}
      profileFunction={() => profileFunction()}
      version={t("general.version")}
      languageImage={getCorrectLanguageImage(lng)}
      onChangeLanguage={toggleLanguage}
    >
      <AccountList />
    </LayoutComponent>
  );
};

const AccountListPage = () => {
  // needed context
  const { keycloakUser } = useContext(KeycloakUserContext);
  const { userCompany } = useContext(CompanyContext);
  const {
    leanAdminTreeData,
    leanProdTreeData,
    pdcaTreeData,
    projektAkteTreeData,
  } = useContext(TreeDataContext);
  const {
    isViewerState,
    toggleViewerState,
    isDesktopMenuOpen,
    toggleIsDesktopMenuOpen,
  } = useContext(GlobaleApplicationSettings);
  const { t } = useTranslation();

  return keycloakUser && userCompany ? (
    <Suspense
      fallback={
        <LoaderComponent inFront showText text={t("general.loading")} />
      }
    >
      <Page
        isDesktopMenuOpen={isDesktopMenuOpen}
        toggleIsDesktopMenuOpen={toggleIsDesktopMenuOpen}
        isViewerState={isViewerState}
        pdcaTreeData={pdcaTreeData}
        toggleViewerState={toggleViewerState}
        keycloakUser={keycloakUser}
        userCompany={userCompany}
        leanAdminTreeData={leanAdminTreeData}
        leanProdTreeData={leanProdTreeData}
        projektAkteTreeData={projektAkteTreeData}
      />
    </Suspense>
  ) : (
    <LoaderComponent inFront showText text={t("general.loading")} />
  );
};

export default AccountListPage;
